import(/* webpackMode: "eager" */ "/var/www/716-cannabis/app/specials/[id]/page.tsx");
